import { Formik, Form, Field, ErrorMessage } from "formik"
import { useState } from "react";
import { Modal } from "react-bootstrap"
import Loader from "../../../Common/Loader/loader";
import * as Yup from 'yup';
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import axios from "axios";
import { toast } from "react-toastify";
const EditTransferstationTransactionModal = ({ showModal, setShow, selectedData, startDate, endDate, VehicleNumber, setEditData,
    zoneId,
    VehicleTypeId, AllTransferStationTransactions }) => {
    const [previewImage, setPreviewImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setPreviewImage(null)
        setShow(false)
    }

    const initialValues = {
        lmcSlipNO: selectedData ? selectedData.lmcSlipNO : '',
        netWeight: selectedData ? selectedData.netWeight : '',
        grossWeight: selectedData ? selectedData.grossWeight : '',
        beforePicture: selectedData ? selectedData.beforePicture : '',
    }
    const validationSchema = Yup.object().shape({

        lmcSlipNO: Yup.string()
         .max(50, 'LMC Slip No cannot exceed 50 characters')
             .matches(/^[a-zA-Z0-9\s]+$/, 'Only alphanumeric characters and spaces are allowed')
            .required('LMC Slip No is required'),

        netWeight: Yup.string()
            .matches(/^\d+(\.\d{1,2})?$/, 'Only numbers with up to 2 decimals allowed')
            .required('Net Weight is required'),

        grossWeight: Yup.string()
            .matches(/^\d+(\.\d{1,2})?$/, 'Only numbers with up to 2 decimals allowed')
            .required('Gross Weight is required'),

        beforePicture: Yup.mixed()
            .test("required", "Before Picture is required", function (value) {
                if (typeof value === "string" && value !== "") return true; // existing image URL
                return value instanceof File; // new file
            })
            .test("fileType", "Unsupported file format", function (value) {
                if (typeof value === "string") return true; // existing image, skip type check
                return value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
            })

    });

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            setIsLoading(true)
            const updateDetails = await axios.put(API_BASE_URL1 + 'MasterCreate/UpdateTransferStationTransaction', { transferStationTransactionId: selectedData.transferStationTransactionId, ...values },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )
            if (updateDetails.status === 200) {
                toast.success(updateDetails.data);

                await AllTransferStationTransactions(
                    startDate,
                    endDate,
                    VehicleNumber,
                    zoneId,
                    "", "", "",
                    VehicleTypeId,
                    ""
                );

                handleClose();
                resetForm();
                setEditData(null)
            }
            setSubmitting(false);

            setIsLoading(false)

        } catch (error) {
            if (error.response?.status === 400) {
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add Route Supervisor";
            toast.error(errorMessage);

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            setIsLoading(false)
        }

    }

    
    return (
        <>
            {isLoading && <Loader />}
            <Modal
                show={showModal}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
                backdrop="static"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Transferstation Transaction
                    </Modal.Title>
                    <i
                        className="fa-solid fa-xmark close-container"
                        onClick={handleClose}
                    ></i>
                </Modal.Header>
                <hr />
                <Modal.Body>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                        validateOnChange={true}
                        validateOnBlur={true}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="LMC Slip No">
                                            LMC slip no <span className="text-danger">*</span>
                                        </label>
                                        <Field name="lmcSlipNO">
                                            {({ field, form }) => (
                                                <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    maxLength={50}
                                                    onInput={(e) => {
                                                        
                                                        e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                                                        form.setFieldValue("lmcSlipNO", e.target.value);
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="lmcSlipNO" component="div" style={{ color: 'red' }} className='small' />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Net Weight">
                                            Net Weight(Kg) <span className="text-danger">*</span>
                                        </label>
                                        <Field name="netWeight">
                                            {({ field, form }) => (
                                                <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    onInput={(e) => {
                                                        let value = e.target.value;
                                                        
                                                        // Remove any non-digit and non-decimal point characters
                                                        value = value.replace(/[^0-9.]/g, "");
                                                        
                                                        // Allow only one decimal point
                                                        value = value.replace(/(\..*?)\./g, "$1");
                                                        
                                                        // Restrict to only 2 digits after decimal point
                                                        const parts = value.split(".");
                                                        if (parts.length > 1 && parts[1].length > 2) {
                                                            parts[1] = parts[1].slice(0, 2);
                                                            value = parts[0] + "." + parts[1];
                                                        }
                                                        
                                                        e.target.value = value;
                                                        form.setFieldValue("netWeight", value);
                                                        
                                                        // Trigger validation to show error message
                                                        form.validateField("netWeight");
                                                    }}
                                                    onBlur={(e) => {
                                                        field.onBlur(e);
                                                        form.validateField("netWeight");
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="netWeight" component="div" style={{ color: 'red' }} className='small' />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Gross Weight">
                                            Gross Weight(Kg) <span className="text-danger">*</span>
                                        </label>
                                        <Field name="grossWeight">
                                            {({ field, form }) => (
                                                <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    onInput={(e) => {
                                                        let value = e.target.value;
                                                        
                                                        // Remove any non-digit and non-decimal point characters
                                                        value = value.replace(/[^0-9.]/g, "");
                                                        
                                                        // Allow only one decimal point
                                                        value = value.replace(/(\..*?)\./g, "$1");
                                                        
                                                        // Restrict to only 2 digits after decimal point
                                                        const parts = value.split(".");
                                                        if (parts.length > 1 && parts[1].length > 2) {
                                                            parts[1] = parts[1].slice(0, 2);
                                                            value = parts[0] + "." + parts[1];
                                                        }
                                                        
                                                        e.target.value = value;
                                                        form.setFieldValue("grossWeight", value);
                                                        
                                                        // Trigger validation to show error message
                                                        form.validateField("grossWeight");
                                                    }}
                                                    onBlur={(e) => {
                                                        field.onBlur(e);
                                                        form.validateField("grossWeight");
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="grossWeight" component="div" style={{ color: 'red' }} className='small' />
                                    </div>
                                                                    
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="beforePicture">
                                            Slip Image<span className="text-danger">*</span>
                                        </label>
                                        <Field name="beforePicture">
                                            {({ form }) => (
                                                <>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={(event) => {
                                                            const file = event.currentTarget.files[0];
                                                            form.setFieldValue("beforePicture", file);
                                                            if (file) {
                                                                setPreviewImage(URL.createObjectURL(file));
                                                            } else {
                                                                setPreviewImage(null);
                                                            }
                                                        }}
                                                    />

                                                    {/* Show preview if user selects a new file */}
                                                    {previewImage && (
                                                        <img
                                                            src={previewImage}
                                                            alt="Preview"
                                                            style={{
                                                                marginTop: "10px",
                                                                width: "100%",           // Use full container width
                                                                maxWidth: "300px",       // Prevent excessive stretching
                                                                maxHeight: "200px",          // Maintain aspect ratio
                                                                objectFit: "contain",
                                                                padding: "4px",
                                                                borderRadius: "4px",
                                                            }}
                                                        />
                                                    )}

                                                    {/* Show existing image if preview is not set */}
                                                    {!previewImage && selectedData?.beforePicture && (
                                                        <img
                                                            src={selectedData.beforePicture}
                                                            alt="Existing"
                                                            style={{
                                                                marginTop: "10px",
                                                                width: "100%",           // Use full container width
                                                                maxWidth: "300px",       // Prevent excessive stretching
                                                                maxHeight: "200px",          // Maintain aspect ratio
                                                                objectFit: "contain",
                                                                padding: "4px",
                                                                borderRadius: "4px",
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </Field>

                                        <ErrorMessage name="beforePicture" component="div" style={{ color: 'red' }} className='small' />
                                    </div>

                                </div>
                                <div className="modal-footer d-flex justify-content-center">
                                    {/* {canWriteValue === true ? */}
                                    <button type="submit" className="deployment-button"
                                        disabled={isSubmitting}
                                    >
                                        <i class="fa-solid fa-check done-container"></i>
                                        {/* {selectedTransferStationIncharge ? t("Update") : t("Save")} */}
                                        Save
                                    </button>
                                    {/* : ''} */}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditTransferstationTransactionModal